// extracted by mini-css-extract-plugin
export var item = "ServiceItem-module--item--TikmX";
export var control = "ServiceItem-module--control--hbM57";
export var control__collapsed = "ServiceItem-module--control__collapsed--P24g3";
export var control__expanded = "ServiceItem-module--control__expanded--I-rxB";
export var body__expanded = "ServiceItem-module--body__expanded--1rCto";
export var body__collapsed = "ServiceItem-module--body__collapsed--Q6ROG";